module.exports = __webpack_public_path__ + "static/fe_icon-30f003b124f49d38386fd5e83e5cd934.png";